// ======================================================================
// File: TransportFilterBar.jsx
// Module: PPE → Transport
// Purpose:
//   Filter/search bar aligned with PPE list screens
// ======================================================================

import React, { useState } from "react";


// ======================================================================
// COMPONENT
// ======================================================================

export default function TransportFilterBar({ onSearch }) {

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    request_type: "",
    from_date: "",
    to_date: "",
  });

  // ------------------------------------------------------------------
  // HANDLE CHANGE
  // ------------------------------------------------------------------
  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  // ------------------------------------------------------------------
  // SEARCH CLICK
  // ------------------------------------------------------------------
  const handleSearch = () => {
    if (onSearch) {
      onSearch(filters);
    }
  };

  // ------------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------------
  return (
    <div className="card glass-card mb-3">
      <div className="card-body">

        <div className="row g-2 align-items-end">

          {/* Search */}
          <div className="col-md-3">
            <label className="form-label">Search</label>
            <input
              type="text"
              name="search"
              placeholder="Transport code / transporter"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          {/* Status */}
          <div className="col-md-2">
            <label className="form-label">Status</label>
            <select
              name="status"
              className="form-select"
              onChange={handleChange}
            >
              <option value="">All Status</option>
              <option value="REQUESTED">Requested</option>
              <option value="BOOKED">Booked</option>
              <option value="IN_TRANSIT">In Transit</option>
              <option value="DELIVERED">Delivered</option>
              <option value="CLOSED">Closed</option>
            </select>
          </div>

          {/* Request Type */}
          <div className="col-md-2">
            <label className="form-label">Type</label>
            <select
              name="request_type"
              className="form-select"
              onChange={handleChange}
            >
              <option value="">All Types</option>
              <option value="INBOUND">Inbound</option>
              <option value="OUTBOUND">Outbound</option>
            </select>
          </div>

          {/* From Date */}
          <div className="col-md-2">
            <label className="form-label">From</label>
            <input
              type="date"
              name="from_date"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          {/* To Date */}
          <div className="col-md-2">
            <label className="form-label">To</label>
            <input
              type="date"
              name="to_date"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          {/* Search Button */}
          <div className="col-md-1 d-grid">
            <button
              className="btn btn-primary"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>

        </div>

      </div>
    </div>
  );
}
